const styles = {
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  filter: { display: 'flex', marginBottom: 10 },
  filterInput: { width: 180 },
  filterOutlined: {
    marginTop: 2,
    fontSize: 16,
    position: 'absolute',
    color: '#364150',
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    color: '#364150',
    marginLeft: 25,
  },
};

export default styles;
